(() => {
    'use strict';

    const updateAnswerCountAlert = (widget, answerCount, resultsNotice) => {
        const alert = widget.find('.answer-count-alert');
        if (resultsNotice) {
            // An anonymous allocate keeps a filtered segment hidden until enough people in it have answered.
            alert.text(resultsNotice);
        } else if (answerCount === 1) {
            alert.text(howspace.translate('allocate_answer_count', {'count': answerCount}));
        } else {
            alert.text(howspace.translate('allocate_answers_count', {'count': answerCount}));
        }
    };

    const updateResults = (widget, notification) => {
        if (real.events.isFromCurrentUser(notification)) {
            howspace.widgets.updateWidget(widget, 'view');
            return;
        }

        if (widget.find('.save-filters-btn').is(':visible')) {
            // Admin is currently viewing some filtered results which are not the widget's saved filters.
            // Do not update the UI in real time in this case.
            return;
        }

        const updatedRows = $(notification.object.average_results ?? '').findIncludingSelf('tr');
        updateAnswerCountAlert(widget, notification.object.answer_count, updatedRows.first().data('results-notice'));

        if (!notification.object.average_results) {
            return;
        }

        const listerTbody = widget.find('.howspace-lister-table tbody');
        updatedRows.each(function () {
            const updatedTr = $(this);
            const origTr = listerTbody.find('tr[data-option-id="' + updatedTr.data('option-id') + '"]');
            origTr.find('.howspace-progress.average').replaceWith(updatedTr.find('.howspace-progress.average'));
            listerTbody.append(origTr);
        });
    };

    howspace.widgets.onEvent('allocate:answer:created', (widget, notification) => {
        if (real.events.isFromCurrentUser(notification)) {
            howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
        }
        updateResults(widget, notification);
    });

    howspace.widgets.onEvent('allocate:answer:updated', updateResults);

    howspace.widgets.onEvent('allocate:answer:deleted', (widget, notification) => {
        if (real.events.isFromCurrentUser(notification)) {
            howspace.workspace.page.pathMode.handleUserHasNotInteracted(widget);
        }
        updateResults(widget, notification);
    });

    const deleteAnswer = (widget, successFn) => {
        if (widget.data('answer-id')) {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/allocateanswer/' + widget.data('answer-id'), {
                type : 'DELETE',
                success : successFn
            });
        } else {
            successFn();
        }
    };

    const submitAnswer = (widget, successFn) => {
        const dataPayload = {
            selected_options: []
        };

        widget.find('.options-wrapper .allocate-option-wrapper').each(function() {
            const option = $(this);
            const id = option.data('id');
            const points = parseInt(option.find('.points').val());
            dataPayload.selected_options.push({
                id: id,
                points: points
            });
        });

        let url;
        if (widget.data('answer-id')) {
            url = '/allocateanswer/' + widget.data('answer-id');
        } else {
            url = '/allocateanswers';
        }

        real.ajax.json(howspace.widgets.getApiUrl(widget) + url, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success : successFn,
            logError : response => {
                return response.status !== 409;
            },
            showErrorNotification : response => {
                return response.status !== 409;
            },
            error : response => {
                real.ajax.loopErrors(response, function(error) {
                    if (error.code === 409) {
                        // User has already answered to allocate, but UI didn't update fast enough and now
                        // user is trying to answer again and conflict occurred. Just update the
                        // whole widget UI at this point.
                        howspace.widgets.updateWidget(widget, 'view');
                    }
                });
            }
        });
    };

    const setLocalStorage = widget => {
        const data = {};
        widget.find('.options-wrapper .allocate-option-wrapper').each(function() {
            const option = $(this);
            const id = option.data('id');
            data[id] = parseInt(option.find('.points').val());
        });
        howspace.widgets.setLocalStorage(widget, howspace.widgets.allocate.POINTS, data);
    };

    const getLocalStorage = widget => {
        const points = howspace.widgets.getLocalStorage(widget, howspace.widgets.allocate.POINTS);
        if (points) {
            widget.find('.options-wrapper .allocate-option-wrapper').each(function() {
                const option = $(this);
                const id = option.data('id');
                const pointsValue = points[id];
                if (pointsValue) {
                    option.find('.points').val(pointsValue);
                }
            });
            updateRemainingPoints(widget);
        }
    };

    const removeLocalStorage = widget => {
        howspace.widgets.removeLocalStorage(widget, howspace.widgets.allocate.POINTS);
    };

    const getRemainingPoints = (widget) => {
        let remaining = widget.data('max-points');

        widget.find('.allocate-options .points').each(function() {
            remaining -= parseInt($(this).val());
        });

        return remaining;
    };

    const updateRemainingPoints = (widget) => {
        const total = widget.data('max-points');
        let remaining = getRemainingPoints(widget);

        if (remaining < 0) {
            widget.find('.options-wrapper .allocate-option-wrapper').each(function() {
                $(this).find('.points').val(0);
            });
            remaining = total;
        }

        const label = widget.find('.remaining > .howspace-form-label-text > span');
        label.text(howspace.translate('allocate_remaining', {'remaining': remaining, 'total': total}));

        widget.find('.submit-btn').prop('disabled', remaining !== 0 || total === 0);

        setLocalStorage(widget);
    };

    const addPoint = (widget, option) => {
        const input = option.find('.points');
        const currentPoints = parseInt(input.val());
        const maxPoints = parseInt(input.attr('max'));
        const remainingPoints = getRemainingPoints(widget);
        if (remainingPoints > 0 && currentPoints < maxPoints) {
            input.val(currentPoints + 1);
            updateRemainingPoints(widget);
        }
    };

    const subtractPoint = (widget, option) => {
        const input = option.find('.points');
        const currentPoints = parseInt(input.val());
        const minPoints = parseInt(input.attr('min'));
        if (currentPoints > minPoints) {
            input.val(currentPoints - 1);
            updateRemainingPoints(widget);
        }
    };

    const startAddPointInterval = function(widget, option) {
        howspace.widgets.allocate.intervalId = setInterval(function() {
            howspace.widgets.allocate.clickCount++;
            addPoint(widget, option);

            if (howspace.widgets.allocate.clickCount % 2 === 0 && howspace.widgets.allocate.intervalTime > 50) {
                howspace.widgets.allocate.intervalTime = Math.max(howspace.widgets.allocate.intervalTime - 100, 50);
                clearInterval(howspace.widgets.allocate.intervalId);
                startAddPointInterval(widget, option);
            }
        }, howspace.widgets.allocate.intervalTime);
    }

    const startSubtractPointInterval = function(widget, option) {
        howspace.widgets.allocate.intervalId = setInterval(function() {
            howspace.widgets.allocate.clickCount++;
            subtractPoint(widget, option);

            if (howspace.widgets.allocate.clickCount % 2 === 0 && howspace.widgets.allocate.intervalTime > 50) {
                howspace.widgets.allocate.intervalTime = Math.max(howspace.widgets.allocate.intervalTime - 100, 50);
                clearInterval(howspace.widgets.allocate.intervalId);
                startSubtractPointInterval(widget, option);
            }
        }, howspace.widgets.allocate.intervalTime);
    };

    const stopInterval = function() {
        clearInterval(howspace.widgets.allocate.intervalId);
        howspace.widgets.allocate.clickCount = 0;
        howspace.widgets.allocate.intervalTime = 350;
    };

    const toggleAverage = (e) => {
        const badge = $(e.target);
        const widget = badge.closest('.widget');

        badge.toggleClass('selected');
        badge.attr('aria-pressed', badge.hasClass('selected') ? 'true' : 'false');

        widget.find('.howspace-progress.average').toggleClass('d-none');
    };

    const toggleMyAnswer = (e) => {
        const badge = $(e.target);
        const widget = badge.closest('.widget');

        badge.toggleClass('selected');
        badge.attr('aria-pressed', badge.hasClass('selected') ? 'true' : 'false');

        widget.find('.howspace-progress.my-answer').toggleClass('d-none');
    };

    howspace.widgets.allocate = {
        intervalId: null,
        clickCount: 0,
        intervalTime: 350,
        POINTS: 'points',
        initView: widget => {
            // Show options button.
            widget.find('.show-options-btn').on('click', () => {
                widget.find('.options-wrapper').removeClass('d-none');
                widget.find('.text-wrapper').addClass('d-none');
                widget.find('.results-wrapper').addClass('d-none');
                widget.find('.show-options-btn').prop('disabled', true);
                widget.find('.show-results-btn').prop('disabled', false);
            });

            // Show results button.
            widget.find('.show-results-btn').on('click', () => {
                widget.find('.options-wrapper').addClass('d-none');
                widget.find('.text-wrapper').addClass('d-none');
                widget.find('.results-wrapper').removeClass('d-none');
                widget.find('.show-options-btn').prop('disabled', false);
                widget.find('.show-results-btn').prop('disabled', true);
            });

            // Submit answer.
            widget.find('.submit-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);

                submitAnswer(widget, () => {
                    howspace.workspace.page.pathMode.handleUserHasInteracted(widget);

                    removeLocalStorage(widget);
                });
            });

            // Remove answer.
            widget.find('.delete-answer-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);

                deleteAnswer(widget, () => {
                    removeLocalStorage(widget);
                });
            });

            // Change answer.
            widget.find('.change-answer-btn').on('click', () => {
                widget.find('.text-wrapper').addClass('d-none');
                widget.find('.results-wrapper').addClass('d-none');
                widget.find('.options-wrapper').removeClass('d-none');
                widget.find('.show-options-btn').prop('disabled', true);
                widget.find('.show-results-btn').prop('disabled', false);
            });

            // Voting.
            widget.find('.allocate-option-wrapper .points').on('input', e => {
                const input = $(e.target);
                const val = input.val();

                if (!val) {
                    input.val(0);
                }

                if (val.startsWith('0') && val.length > 1) {
                    input.val(val.substring(1));
                }

                if (getRemainingPoints(widget) < 0) {
                    input.val(0);
                }

                updateRemainingPoints(widget);
            });

            widget.find('.allocate-option-wrapper .option-btn').on('click', e => {
                const btn = $(e.target);
                const option = btn.closest('.allocate-option-wrapper');

                addPoint(widget, option);
            });

            widget.find('.allocate-option-wrapper .plus-btn').on('keypress', e => {
                if (e.keyCode !== 13 && e.keyCode !== 32) {
                    return;
                }

                const btn = $(e.target);
                const option = btn.closest('.allocate-option-wrapper');

                addPoint(widget, option);
            });

            widget.find('.allocate-option-wrapper .plus-btn').on('mousedown', e => {
                if (e.which !== 1) {
                    return;
                }

                const btn = $(e.target);
                const option = btn.closest('.allocate-option-wrapper');

                addPoint(widget, option);

                startAddPointInterval(widget, option);
            });

            widget.find('.allocate-option-wrapper .plus-btn').on('mouseup', stopInterval);
            widget.find('.allocate-option-wrapper .plus-btn').on('mouseleave', stopInterval);

            widget.find('.allocate-option-wrapper .minus-btn').on('keypress', e => {
                if (e.keyCode !== 13 && e.keyCode !== 32) {
                    return;
                }

                const btn = $(e.target);
                const option = btn.closest('.allocate-option-wrapper');

                subtractPoint(widget, option);
            });

            widget.find('.allocate-option-wrapper .minus-btn').on('mousedown', e => {
                if (e.which !== 1) {
                    return;
                }

                const btn = $(e.target);
                const option = btn.closest('.allocate-option-wrapper');

                subtractPoint(widget, option);

                startSubtractPointInterval(widget, option);
            });

            widget.find('.allocate-option-wrapper .minus-btn').on('mouseup', stopInterval);
            widget.find('.allocate-option-wrapper .minus-btn').on('mouseleave', stopInterval);

            // Results rendered event.
            widget.find('.howspace-lister').on(howspace.components.lister.LIST_ITEMS_RENDERED, () => {
                const tr = widget.find('.howspace-lister-table tbody tr').first();
                updateAnswerCountAlert(widget, parseInt(tr.data('answer-count')), tr.data('results-notice'));
            });

            // Legend badges.
            widget.on('click', '.average-badge', toggleAverage);
            widget.on('keydown', '.average-badge', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleAverage(e);
                    return false;
                }
            });

            widget.on('click', '.my-answer-badge', toggleMyAnswer);
            widget.on('keydown', '.my-answer-badge', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleMyAnswer(e);
                    return false;
                }
            });

            getLocalStorage(widget);
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Max points.
            widget.find('input[name="max_points"]').on('input', e => {
                const input = $(e.target);
                const val = input.val();
                if (val) {
                    input.val(Math.max(1, parseInt(val)));
                } else {
                    input.val(1);
                }
            });

            // Add option button.
            widget.find('.add-option-btn').on('click', () => {
                widget.find('.allocate-options').removeClass('d-none');

                const sortableList = widget.find('.howspace-sortable-list');
                howspace.components.sortableList.addItem(sortableList);
            });

            // Add first option.
            if (widget.find('.allocate-option').length === 0) {
                widget.find('.add-option-btn').trigger('click');
            }
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            dataPayload.allocate_options = [];
            widget.find('.allocate-option-wrapper:not(.deleted)').each(function() {
                dataPayload.allocate_options.push(real.form.getDataPayload($(this)));
            });
            return dataPayload;
        },
        updateFilter : (widget) => {
            const lister = widget.find('.howspace-lister');
            howspace.components.lister.reload(lister);
        }
    };
})();
